export const SubscriptionDictionary = {
    SubscriptionId: 'AssinaturaPessoaId',
    PlanName: 'AssinaturaDescricao',
    CycleName: 'AssinaturaCondicaoDescricao',
    StartOnUtc: 'DataInicio',
    EndOnUtc: 'DataFim',
    NextDueOnUtc: 'DataProximoVencimento',
    FixedInstallmentAmount: 'VrPrimeiroVencimento',
    ClosedOnUtc: 'DataEncerramento',
    TransferredOnUtc: 'DataTransferencia',
    DataCadastro: 'DataCadastro',
    CardId: 'CardId',
};
